<template>
    <div>
        <ul>
            <router-link class="" :to="'/admin/stocks'" tag="li"><a>Баннер</a></router-link>
            <router-link class="" :to="'/admin/histories'" tag="li"><a>History</a></router-link>
            <router-link class="" :to="'/admin/managers'" tag="li"><a>Managers</a></router-link>
            <router-link class="" :to="'/admin/users'" tag="li"><a>Users</a></router-link>
            <router-link class="" :to="'/admin/settings'" tag="li"><a>Settings</a></router-link>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "Menu"
    }
</script>

<style scoped>

</style>-



// WEBPACK FOOTER //
// src/views/app/admin/Menu.vue